import SignupForm from "../components/SignUp/SignupForm"

export const Signup=()=>{
    return <SignupForm/>
}